import React from 'react';

import { PayoutsHistoryTable } from '.';

const PayoutsHistory = () => {
  return (
    <div className="payouts__history">
      <PayoutsHistoryTable />
    </div>
  );
};

export { PayoutsHistory };
